const mapModule = {
  state: {
    savedViewExtent: {
      search: null,
      related: null,
      location: null
    },
    geoLocation: null
  },
  mutations: {
    setSavedViewExtent (state, payload) {
      state.savedViewExtent = {
        ...state.savedViewExtent,
        ...payload
      }
    },
    setGeoLocation (state, payload) {
      state.geoLocation = payload
    }
  },
  actions: {
    setSavedViewExtent (context, payload) {
      const type = Object.keys(payload)[0]
      type !== 'undefined' && context.commit('setSavedViewExtent', payload)
    },
    setGeoLocation (context, payload) {
      context.commit('setGeoLocation', payload)
    }
  },
  getters: {
    savedViewExtentForType: state => type => {
      return type === 'search' ? state.savedViewExtent[type] : null
    }
  }
}

export default mapModule
